import { render, staticRenderFns } from "./abnormal-users.vue?vue&type=template&id=d9abfe2a&scoped=true&"
import script from "./abnormal-users.vue?vue&type=script&lang=js&"
export * from "./abnormal-users.vue?vue&type=script&lang=js&"
import style0 from "./abnormal-users.vue?vue&type=style&index=0&id=d9abfe2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9abfe2a",
  null
  
)

export default component.exports